module.exports = __webpack_public_path__ + "assets/img/arrow-left.0a1a4724.svg";